import React, { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useT, LANG_LIST, LANG_LABELS } from "../../lib/i18n";

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANG_LABELS[lang];

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-switcher-btn"
        aria-label="Change language"
        className={`flex items-center gap-1.5 rounded-full border border-[#1E3A5D]/20 bg-white/80 hover:bg-white transition-colors ${
          compact ? "px-3 py-1.5" : "px-3.5 py-2"
        }`}
      >
        <span className="text-base leading-none">{current.flag}</span>
        <span className="font-display text-[10px] tracking-[0.2em] text-[#1E3A5D] font-semibold uppercase">
          {lang}
        </span>
        <ChevronDown className={`w-3 h-3 text-[#1E3A5D] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          data-testid="lang-switcher-menu"
          className="absolute right-0 mt-2 w-44 bg-white rounded-xl border border-[#1E3A5D]/15 shadow-xl overflow-hidden z-50"
        >
          {LANG_LIST.map((code) => {
            const info = LANG_LABELS[code];
            const active = code === lang;
            return (
              <button
                key={code}
                onClick={() => { setLang(code); setOpen(false); }}
                data-testid={`lang-option-${code}`}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-left text-sm transition-colors ${
                  active ? "bg-[#1E3A5D] text-white" : "text-[#1E3A5D] hover:bg-[#F5EFE4]"
                }`}
              >
                <span className="text-base leading-none">{info.flag}</span>
                <span className={`font-serif-body ${active ? "font-semibold" : ""}`}>{info.name}</span>
                {active && <Globe className="w-3.5 h-3.5 ml-auto" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
